exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dashboard-screen-page .dashboard-default[data-v-2ed44d89] {\n  background-color: black;\n}\n.dashboard-screen-page .brandImageLogo[data-v-2ed44d89] {\n  max-height: 150px;\n  max-width: 250px;\n}\n.dashboard-screen-page .dashboard-infobox[data-v-2ed44d89] {\n  position: fixed;\n  top: 40px;\n  right: 0;\n  min-width: 650px;\n  background-color: #402916;\n  font-size: 13px;\n  line-height: 13px;\n  color: white;\n  z-index: 100;\n  border-top-left-radius: 5px;\n  border-bottom-left-radius: 5px;\n}\n.dashboard-screen-page .dashboard-infobox .brandImageLogo[data-v-2ed44d89] {\n  max-height: 70px;\n  max-width: 160px;\n}", ""]);

// exports
